import React from "react";
import PropTypes from "prop-types";
import { AlertFilled as AlertIcon } from "@churchofjesuschrist/eden-icons";
import { accentColorDanger } from "@churchofjesuschrist/eden-style-constants";
import Alert from "./Alert";

/**
 * Displays error information in a box
 */
import { jsx as _jsx } from "react/jsx-runtime";
const Error = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Alert, {
    ...props,
    Icon: AlertIcon,
    color: accentColorDanger,
    children: children
  });
};
Error.propTypes = {
  /** Content inside the alert body */
  children: PropTypes.node.isRequired,
  /** Callback function to execute when user dismisses the alert */
  onClose: PropTypes.func,
  /** Label for the "close" control. */
  closeLabel: PropTypes.string
};
export default Error;